import { GTagEvents } from '@/lib/gTagManager';
import { CustomWebToAppEvents } from '@/models/enum/app-wrapper.enum';

export const sendEventToAppWrapper = (
  message: CustomWebToAppEvents | GTagEvents,
  params?: unknown,
): void => {
  if (window && window.parent && window.parent.postMessage) {
    window.parent.postMessage({ event_message: message, event_params: params }, '*');
  }
};

// Types for events received from mobile app
export type AppToWebEvents =
  | 'biometric_credentials'
  | 'biometric_available'
  | 'biometric_credentials_cleared';

export type BiometricCredentialsPayload = {
  email: string;
  password: string;
};

export type BiometricAvailablePayload = {
  available: boolean;
};

export type AppToWebEventPayload = BiometricCredentialsPayload | BiometricAvailablePayload;

export const subscribeToAppWrapperEvents = (
  callback: (event: AppToWebEvents, params: AppToWebEventPayload) => void,
): (() => void) => {
  const handler = (event: MessageEvent) => {
    if (event.source !== window.parent) return;

    const { event_message, event_params } = event.data || {};

    // Validate message structure
    if (!event_message) return;

    // Validate it's a known event type from mobile app
    const validEvents: AppToWebEvents[] = [
      'biometric_credentials',
      'biometric_available',
      'biometric_credentials_cleared',
    ];
    if (!validEvents.includes(event_message)) return;

    callback(event_message, event_params);
  };

  window.addEventListener('message', handler);
  return () => window.removeEventListener('message', handler);
};
